import { Component, ElementRef, forwardRef, HostListener, Input, OnInit, ViewChild } from "@angular/core";
import { IMyDateModel, INgxMyDpOptions } from "ngx-mydatepicker";
import { TotalFeeResponse } from "../../../objects/report/totalFeeResponse";
import { ReportService } from "../../../services/reportService";
import { ActivatedRoute, Route } from "@angular/router";
import { ReportSearchRequest } from "../../../objects/requests/reportSearchRequest";
import { AgentSelectorComponent } from "../filterSelectors/agentSelector/agentSelector.component";
import { User } from "../../../objects/users/user";
import { StorageManager } from "../../../common/managers/storageManager";
import { DateRangeSelectorComponent } from "../filterSelectors/dateSelector/dateRangeSelector.component";
import { ReportType } from "../../../objects/report/reportType";
import { ColorHelper } from "../../../common/helpers/colorHelper";
import { AgentColorLink } from "../../../objects/report/agentColorLink";
import { Cookie } from "ng2-cookies/ng2-cookies";
import { ConfigService } from "../../../services/configService";
import { Guid } from "../../../common/helpers/guidHelper";
import { HashHelper } from "../../../common/helpers/hashHelper";
import { FeeTotal } from "../../../objects/report/feeTotal";
import * as _ from "lodash";
import * as moment from "moment";
import { ChartsHelper } from "../../../common/helpers/chartsHelper";
import { WizardComponent } from "ngx-wizard";

/**
 * Created by alex.y on 9/20/2017.
 */
@Component({
    selector: "report-total-fee",
    templateUrl: "./totalAmount.component.html",
    moduleId: module.id.toString()
})
export class TotalAmountComponent implements OnInit {

    @Input()
    public reportType: ReportType;

    public repType = ReportType;

    public totalFees: Array<TotalFeeResponse> = [];
    public currentAgent: User = new User();

    public startDate?: Date = null;
    public endDate?: Date = null;
    public agentIds: Array<number> = [];

    public isProcessing: boolean = false;
    public canvasHeightCombined: number;

    public agentColors: Array<AgentColorLink> = [];

    public allAgents: Array<User> = [];

    @ViewChild('reportWizard') public wizard: WizardComponent;

    @ViewChild('agentSelector') public agentSelector: AgentSelectorComponent;
    @ViewChild('agentSelectorCombined') public agentSelectorCombined: AgentSelectorComponent;

    @ViewChild('dateRangeSelectorCombined') public dateRangeSelectorCombined: DateRangeSelectorComponent;
    @ViewChild('dateRangeSelectorDate') public dateRangeSelectorDate: DateRangeSelectorComponent;

    public constructor(public reportService: ReportService, private route: ActivatedRoute, private storageManager: StorageManager, private configService: ConfigService) {
    }

    public ngOnInit(): void {
        this.totalFees = this.route.snapshot.data.totalFee;

        this.storageManager.getCurrentUser().then(x => {
            this.currentAgent = x;

            if (!this.canAccess())
                this.allAgents = this.route.snapshot.data.allAgents.find((x: any) => x.Id == Cookie.get(this.configService.config.UserCookieName));
            else
                this.allAgents = this.route.snapshot.data.allAgents;

            this.generateColors();
            this.convertDateModelToDate(this.dateRangeSelectorDate.getCurrentDateModel());
            ChartsHelper.convertAndCutDate(this.totalFees, this.startDate, this.endDate);
        })
    }

    public handleDayChanging(date: Object): void {
        this.convertDateModelToDate(date);
        this.search();
    }

    public handleAgentsChanging(agentIds: Array<number>): void {
        this.agentIds = agentIds;

        if(this.agentIds.length == 0){
            this.totalFees = [];
            return;
        }

        this.search();
    }

    public searchByAgentId(): void {
        this.startDate = new Date((new Date()).setDate(new Date().getDate() - 7));
        this.endDate = new Date();

        this.agentSelector.setValue();
    }

    public searchByDate() {
        this.agentIds = [];

        this.handleDayChanging(this.dateRangeSelectorDate.getCurrentDateModel());
    }

    public combinedSearch(): void {
        this.convertDateModelToDate(this.dateRangeSelectorCombined.getCurrentDateModel());
        if (this.agentSelectorCombined)
            this.agentSelectorCombined.setValue();
        else {
            this.search()
        }
    }

    private search(): void {
        this.isProcessing = true;

        this.reportService.getTotalFee(new ReportSearchRequest({
            StartDate: this.startDate,
            EndDate: this.endDate,
            AgentIds: !this.canAccess() ? [this.currentAgent.Id] : (this.agentIds == null ? [] : this.agentIds),
            ReportType: this.reportType
        })).then(response => {
            this.isProcessing = false;

            if (!response || !response.Data)
                return;

            this.totalFees = response.Data;

            ChartsHelper.convertAndCutDate(this.totalFees, this.startDate, this.endDate);
        })
    }

    private convertDateModelToDate(date: Object): void {
        let startDate: Object = date['beginDate'];
        let endDate: Object = date['endDate'];

        this.startDate = new Date(startDate['year'], startDate['month'] - 1, startDate['day'], 0, 0, 0);
        this.endDate = new Date(endDate['year'], endDate['month'] - 1, endDate['day'], 0, 0, 0);
    }

    private canAccess(): boolean {
        if (this.currentAgent.Groups.find(x => x.Name == "Super Admin"))//SUPER ADMIN
            return true;

        return false;
    }

    private generateColors(): void {
        for (let i = 0; i < this.allAgents.length ; i++) {
            let color = '#' + ColorHelper.intToRGB(HashHelper.hashCode(this.allAgents[i].Email + Guid.newGuid()));

            this.agentColors.push(new AgentColorLink({
                Email: this.allAgents[i].Email,
                color: color
            }));
        }
    }

}


// WEBPACK FOOTER //
// ./app/components/reports/totalAmount/totalAmount.component.ts